var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"movings",attrs:{"title":"Movings"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.select},slot:"tools"}),_c('div',{staticClass:"layout"},[_c('date-picker-std-view',{staticClass:"date",attrs:{"status":_vm._state},on:{"browse":_vm.updateState},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('div',{staticClass:"tasks"}),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			/*{
				label: 'Status',
				name: ['_embedded', 'status'],
				translation: _status,
				template: {
					name: 'status',
					params: {
						color: {
							name: ['_embedded', 'status'],
							translation: _statusColors
						},
						description: {
							name: ['_embedded', 'status'],
							translation: _statusDesc
						}
					}
				}
			},*/
			/*{
				label: 'Oprettet',
				name: 'created',
				filter: 'timestamp'
			},*/
			{
				label: 'Type',
				name: 'type',
				translation: _vm._types,
				template: {
					name: 'status',
					params: {
						color: {
							name: 'type',
							translation: _vm._typeColors
						},
						description: {
							data: ''
						},
						subtitle: {
							name: ['_embedded', 'sub_type', 'label'],
							default: null
						}
					}
				}
			},
			{
				label: 'Nr',
				name: 'num',
				filter: 'integer'
				//filter: 'float',
				//align: 'right'
			},
			/*{
				label: 'Kunde',
				name: ['_embedded', 'contact', 'name']
			},*/
			{
				label: 'Navn',
				name: 'name'
			},
			{
				label: 'Ansvarlig',
				name: ['_embedded', 'employee', 'name']
			},
			{
				label: 'Kostpris',
				data: '-'
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				}
			}	
		],"items":_vm.items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }